import { Bot } from '@common-models/bot';

/**
 * FE#193 — the client-editable fields of a Bot that a save/patch is allowed to
 * write. Everything else on the Bot document is server-owned (`owner`,
 * `activeDeploymentId`, `updatedAt`, `botStats`) or identity (`_id`) and must
 * NOT be echoed back: `saveBotThunk` used to spread `...currentBot` into the
 * create/patch body, so a stale client copy of those fields was written over
 * the server's authoritative values on every save.
 */
export const BOT_EDITABLE_FIELDS = [
    'name',
    'description',
    'botSettings',
    'viewport',
] as const;

/**
 * Build the narrowed save payload for a bot: only the editable fields that are
 * actually present on `bot`, plus the freshly-serialized `flowJSON`. Never
 * includes `_id` (the caller adds it as the patch identity) or any server-owned
 * field.
 */
export function buildBotSavePayload(
    bot: Partial<Bot> | undefined,
    flowJSON: string,
): Partial<Bot> {
    const payload: Partial<Bot> = { flowJSON };
    if (!bot) return payload;

    for (const key of BOT_EDITABLE_FIELDS) {
        const value = bot[key];
        if (value !== undefined) {
            (payload as Record<string, unknown>)[key] = value;
        }
    }
    return payload;
}
